import { render } from "./access-denied-page.vue?vue&type=template&id=17f52d0f&scoped=true"
const script = {}

import "./access-denied-page.vue?vue&type=style&index=0&id=17f52d0f&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f52d0f"]])

export default __exports__